import FeesOverview from './FeesOverview';
import ApproveManagementFeesSummary from './ApproveManagementFeesSummary';
import { useState } from 'react';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { CalendarDay } from 'further-ui/utils';
import {
  LpFeeCalculationBasis,
  LpFeeCommitmentStatus,
} from 'further-types/lp/lp-fee-template';
import { FundingSource } from 'further-types/lp/investment';
import { TransactionOperation } from 'further-types/lp/transaction';
import { ActionTransactionSubType } from 'further-types/lp/action';
import { ListLpFeesCategory } from 'further-types/lp/lp-fee';

type FullFeeData = {
  _id: string;
  feeActionId?: string;
  limitedPartner: string;
  disableUnapprove?: boolean;
  feeActionCreatedAt: CalendarDay;
  accrualDate: CalendarDay;
  calculationBasis: LpFeeCalculationBasis;
  lpFeeTemplateName: string;
  lpFeeTemplateFeeName: string;
  lpFeePaymentDate: string;
  insideOutsideCommitment: LpFeeCommitmentStatus;
  feeExTaxLcy: number;
  salesTaxAmountLcy: number;
  feeIncTaxLcy: number;
  generalCapital: number;
  fundingSource: FundingSource;
  isFromEqualisation?: boolean;
};

type Transaction = {
  transactionTypeId: string;
  amountIncVatTcy: number;
  amountExVatTcy: number;
  operationType: TransactionOperation;
  transactionSubType: ActionTransactionSubType;
  transactionCurrency: CurrencyCode;
};

type DefaultTransactions = {
  insideCommitment: Array<Transaction>;
  outsideCommitment: Array<Transaction>;
};

export type ApprovalSummaryData = {
  id: string;
  date: CalendarDay;
  fullFeeData: Array<FullFeeData>;
  defaultTransactions: DefaultTransactions;
  feeType: ListLpFeesCategory | undefined;
};

const FeeManager: React.FC = () => {
  const [isApprovalStep, setIsApprovalStep] = useState(false);
  const [approvalSummaryData, setApprovalSummaryData] =
    useState<ApprovalSummaryData>({
      id: '',
      date: new CalendarDay(new Date()),
      fullFeeData: [],
      defaultTransactions: {
        insideCommitment: [],
        outsideCommitment: [],
      },
      feeType: undefined,
    });

  const handleGotoApproval = () => {
    if (!approvalSummaryData.fullFeeData.length) return;
    setIsApprovalStep(true);
  };

  const handleGoBackToOverview = () => {
    setIsApprovalStep(false);
    setApprovalSummaryData({
      id: '',
      date: new CalendarDay(new Date()),
      fullFeeData: [],
      defaultTransactions: {
        insideCommitment: [],
        outsideCommitment: [],
      },
      feeType: undefined,
    });
  };

  return !isApprovalStep ? (
    <FeesOverview
      onGoToApproval={handleGotoApproval}
      selectedFeeGroupId={approvalSummaryData.id}
      setApprovalSummaryData={setApprovalSummaryData}
    />
  ) : (
    <ApproveManagementFeesSummary
      onBack={handleGoBackToOverview}
      approvalSummaryData={approvalSummaryData}
      setApprovalSummaryData={setApprovalSummaryData}
    />
  );
};

export default FeeManager;
